import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@ami/react/core';
import { dealerUserService } from '../../../dealer-users/dealerUserService';
import { NotificationManager } from 'react-notifications';

export default class DealerInvitationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
    };
  }

  static propTypes = {
    onChanged: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    dealerUserId: PropTypes.string.isRequired,
    dealerUserName: PropTypes.string.isRequired,
  };

  hide = () => this.props.onHide();

  save = async () => {
    const { dealerUserId } = this.props;
    this.setState({ saving: true });
    dealerUserService
      .sendInvitationEmail(dealerUserId)
      .then(async () => {
        this.setState({ saving: false });
        NotificationManager.success('Invitation email sent successfully', '', 3 * 1000);
        this.props.onChanged();
        this.hide();
      })
      .catch(() => console.log('An error ocurred sending the invitation email'))
      .finally(() => this.setState({ sendingInvitation: false }));
  };

  render() {
    const { show } = this.props;
    const { dealerUserName } = this.props;
    const { saving } = this.state;

    if (!show) return null;

    return (
      <Modal
        title="Confirm Invite"
        show={show}
        onShowUpdated={() => { }}
        okTitle="Yes"
        cancelTitle="No"
        onOk={this.save}
        showCancel={true}
        onCancel={this.hide}
        submitting={saving}
      >
        <p>Are you sure you want to send an invitation to {dealerUserName}?</p>
      </Modal>
    );
  }
}
